"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var util_1 = require("../util");
var Lifecycles = (function (_super) {
    tslib_1.__extends(Lifecycles, _super);
    function Lifecycles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lifecycles.prototype.componentDidMount = function () {
        return this.props.didMount(this.props);
    };
    Lifecycles.prototype.shouldComponentUpdate = function (nextProps) {
        var result = this.props.shouldUpdate(nextProps, this.props);
        return typeof result === 'boolean' ? result : true;
    };
    Lifecycles.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        return this.props.getSnapshotBeforeUpdate(prevProps, this.props) || null;
    };
    Lifecycles.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        return this.props.didUpdate(this.props, prevProps, snapshot);
    };
    Lifecycles.prototype.componentWillUnmount = function () {
        return this.props.willUnmount(this.props);
    };
    Lifecycles.prototype.componentDidCatch = function (error, info) {
        return this.props.didCatch(error, info, this.props);
    };
    Lifecycles.prototype.render = function () {
        return this.props.children;
    };
    Lifecycles.defaultProps = {
        didMount: util_1.noop,
        shouldUpdate: util_1.noop,
        getSnapshotBeforeUpdate: util_1.noop,
        didUpdate: util_1.noop,
        willUnmount: util_1.noop,
        didCatch: util_1.noop,
    };
    return Lifecycles;
}(react_1.Component));
exports.Lifecycles = Lifecycles;
//# sourceMappingURL=index.js.map